export default __webpack_public_path__ + "static/media/telegram.49d826f7.svg";